<!-- Global drawer hosting the real Case Management board. Slides in from the
     right over the current view; the same <app-task-management-wf> used on the
     Case Management page renders here. Opened via TaskpanelService.openCaseSidebar(). -->

<!-- Backdrop -->
<div class="gcs-backdrop" *ngIf="isOpen" (click)="close()"></div>

<aside class="gcs-panel" [class.gcs-open]="isOpen" role="dialog" aria-modal="true" aria-label="Cases">

  <!-- Header -->
  <div class="gcs-header">
    <div class="gcs-header-title">
      <span class="gcs-header-label">Cases</span>
      <span class="gcs-header-tag" *ngIf="tagContext?.tag_id != null" matTooltip="Tag ID">
        {{ tagContext?.tag_id }}
      </span>
    </div>
    <button type="button" class="gcs-close-btn" (click)="close()" matTooltip="Close" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- The real board. Mounted only while open so it loads fresh each time
       (data is cached in TaskMgmtService, so re-open is fast). -->
  <div class="gcs-body">
    <app-task-management-wf *ngIf="isOpen" moduleName="Case Management" [sidebarMode]="true"
      [tagContext]="tagContext"></app-task-management-wf>
  </div>

</aside>
